import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { UiService } from '../../../services/api.services';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'portal-modal',
  templateUrl: './portal-modal.component.html',
  styleUrls: ['./portal-modal.component.scss'],
})
export class PortalModalComponent implements OnInit, OnDestroy {

  @Input() bodycolor: string;
  @Input() title: string;
  @Input() showBackButton: string;
  @Input() header: string;
  @Input() isPopover: boolean;
  @Input() isModal: boolean;
  showBackButtonBoolean = true;
  showHeader = false;
  private loginRedirectSubscription: Subscription;

  constructor(private modalController: ModalController, private popoverCtrl: PopoverController, private uiService: UiService) { }

  ngOnInit() {
    this.loginRedirectSubscription = this.uiService.subscribeToLoginRedirectEvent( () => {
      this.dismiss();
    });
    if (this.showBackButton && this.showBackButton.toLowerCase() === 'false') {
      this.showBackButtonBoolean = false;
    }
    if (this.header && this.header.toLowerCase() === 'true') {
      this.showHeader = true;
    }
  }

  ngOnDestroy() {
    if (this.loginRedirectSubscription) {
      this.loginRedirectSubscription.unsubscribe();
    }
  }

  dismiss() {
    if (this.isPopover) {
      this.popoverCtrl.dismiss({
        dismissed: true
      });
    }
    if (this.isModal) {
      this.modalController.dismiss({
        dismissed: true
      });
    }
  }
}
